import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import PaintBrushIconSvg from './PaintBrushIconSvg'

const PaintBrushIcon = (props: IconProps): ReactElement => (
    <Icon component={PaintBrushIconSvg} {...props} />
)

export default PaintBrushIcon
